// Generated by scripts/build-ui-icons.mjs.
export { Money as default } from "../ui/glyphs-5";
